import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import Section from "./section"

const MHeadline = (props) => {
  return (
    <Section baseClass="m-Headline" defaultPaddingTop="small" data={props.data}>
      <div className="m-Headline-wrapper">
        <div className="m-Headline-container">
          <div className="m-Headline-content">
            <div className="c-Headline">
              <DfbHeadline
                headline={props.data.headline}
                headline_level="h3"
                add_class="c-Headline-strokeLine"
              />
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MHeadline
